import { useState, useContext } from "react";
import Input from '../../form/Input';
import styles from '../../form/Form.module.css';
import { Context } from "../../../context/UserContext";
import { Link } from "react-router-dom";

function Login() {
    const [user, setUser] = useState({});
    const { login } = useContext(Context);

    // Formata o CPF diretamente para o formato 000.000.000-00
    function maskCPF(value) {
        return value
            .replace(/\D/g, '')                  // Remove tudo que não for dígito
            .slice(0, 11)                        // Limita a no máximo 11 números
            .replace(/(\d{3})(\d)/, '$1.$2')     // Coloca o primeiro ponto
            .replace(/(\d{3})(\d)/, '$1.$2')     // Coloca o segundo ponto
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2'); // Coloca o traço no final
    }

    function handleChange(e) {
        const { name, value } = e.target;

        if (name === 'document') {
            setUser({
                ...user,
                document: maskCPF(value),
            });
            return;
        }

        setUser({ ...user, [name]: value });
    }

    function handleSubmit(e) {
        e.preventDefault();

        // Envia o payload com o CPF limpo (apenas números) para a API
        const payload = {
            ...user,
            document: user.document ? user.document.replace(/\D/g, '') : ''
        };

        login(payload);
    }

    return (
        <section className={styles.form_container}>
            <h1>Entrar</h1>
            <form onSubmit={handleSubmit}>
                <Input 
                    text="CPF" 
                    type="tel"
                    inputMode="numeric"
                    name="document" 
                    placeholder="000.000.000-00" 
                    handleOnChange={handleChange}
                    value={user.document || ''}
                />
                <Input 
                    text="Senha" 
                    type="password" 
                    name="password" 
                    placeholder="Digite a sua senha" 
                    handleOnChange={handleChange}
                    value={user.password || ''}
                />
                <input type="submit" value="Entrar" />
                <p>Não tem conta? <Link to="/register">Clique aqui</Link> para cadastrar!</p>
            </form>
        </section>
    );
}

export default Login;